/* eslint-disable max-len */
import sha256 from 'crypto-js/sha256';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import window from 'global/window';
import document from 'global/document';
import process from 'global/process';
import deepmerge from 'deepmerge';
import axios from 'axios';
import DOMPurify from 'isomorphic-dompurify';
import logger from './logger';
import {
  ROUTER_BASENAME,
  ENVIRONMENT_CONSTANTS,
  PRELOADED_STATE_KEY,
  // LOCAL_STORAGE_VIEW_COUNT_KEY,
  // UNAUTH_VIEW_COUNT_MAX,
  COURSE_API_HOST,
  COURSE_PREVIEW_API_HOST,
  CONTENTFUL_SPACE_ID,
  CONTENTFUL_ENVIRONMENT_ID,
  SEARCH_API,
  LRS_CONTEXT_EXTENSIONS,
  LRS_EXTENSIONS_PURPOSE,
  AWS_ENV_VARS, LOCAL_STORAGE_ANONYMOUS_ID, LOCAL_STORAGE_LRS_KEY,
  FILEMANAGER_PROXY_HOST,
  LRS_APPID_LRNO,
  LRS_VERB_COMPLETED,
  EDC_SLUGS_ENROLLMENT_ZH_CN,
  EDC_SLUGS_ENROLLMENT_KO_KR,
  EDC_SLUGS_ENROLLMENT_JA_JP,
  EDC_SLUGS_ENROLLMENT_IT_IT,
  EDC_SLUGS_ENROLLMENT_FR_FR,
  EDC_SLUGS_ENROLLMENT_ES_ES,
  EDC_SLUGS_ENROLLMENT_DE_DE,
  EDC_SLUGS_ENROLLMENT_EN_US,
  // LEARNING_MODE_MICROLEARNING,
  // ITEM_TYPE_PDF,
  PERSONALIZATION_EXPERIMENT_ACTIVETRIALONLY,
  PERSONALIZATION_EXPERIMENT_ACTIVECOMMONLY,
  PERSONALIZATION_EXPERIMENT_ACTIVETRIALANDCOMM,
  PERSONALIZATION_EXPERIMENT_ATOTREATMENT,
  PERSONALIZATION_EXPERIMENT_ACOTREATMENT,
  PERSONALIZATION_EXPERIMENT_ATACTREATMENT,
  PERSONALIZATION_EXPERIMENT_ATOCONTROL,
  PERSONALIZATION_EXPERIMENT_ACOCONTROL,
  PERSONALIZATION_EXPERIMENT_ATACCONTROL,
  PERSONALIZATION_EXPERIMENT_CONTROL,
  PERSONALIZATION_EXPERIMENT_TREATMENT,
  PERSONALIZATION_EXPERIMENT_EXPIREDTRIALONLY,
  PERSONALIZATION_EXPERIMENT_ETOCONTROL,
  PERSONALIZATION_EXPERIMENT_ETOTREATMENT,
  LEARNING_PLAN_HOST_COMMON,
  INDUSTRY_RELEVANT_LEARNING_AND_CERT_PREP,
  IRLCP_EXPERIMENT_CONTROL,
  IRLCP_EXPERIMENT_TREATMENT,
  COACHING_CATALOG_ACTIVE_FILTERS,
  coachTypeConstants,
  COACHING_TYPE_KEY_FAST_TRACK,
  WTIH_APIKEY,
  WTIH_SECRET,
  UGC_FILTER_KEY,
} from './constants';
import { LoginClickHandler } from './login';
import chunkArrayFunc from './chunkArray';

export const oneWayHash = (data) => sha256(`sdgjk34${data}`);

export const isTouchDevice = () => (('ontouchstart' in window) || (window.navigator?.maxTouchPoints > 0) || (window.navigator?.msMaxTouchPoints > 0));

export const isFromAccount = () => {
  const safeLocation = window.location || (typeof window.location !== 'undefined' ? window.location : { search: '', pathname: '', hash: '' });
  const urlParams = new URLSearchParams(safeLocation.search);
  const { referrer } = document;

  if (urlParams.get('src') === 'acct') {
    return true;
  }

  const referrerPattern = /.*manage\.autodesk\.com/;
  if (referrerPattern.test(referrer)) {
    return true;
  }

  return false;
};

export const isFromCoachingCatalog = () => {
  const safeLocation = typeof window !== 'undefined' && window.location ? window.location : { search: '', pathname: '', hash: '' };
  const urlParams = new URLSearchParams(safeLocation.search);
  const referrer = typeof document !== 'undefined' && document.referrer ? document.referrer : '';

  if (urlParams.get('src') === 'catalog') {
    return true;
  }

  const referrerPattern = /(\/.*)\/coaching-catalog(\/.*)?/;
  if (referrerPattern.test(referrer)) {
    return true;
  }

  return false;
};

export const isCustomerSuccessOfferingOn = ({ env }) => {
  // TODO: Add logic to check if customer success offering is on from LaunchDarkly
  if (env === 'prod') {
    return false;
  }
  const urlParams = new URLSearchParams(window?.location?.search);
  return urlParams.get('cs') === '1';
};

export const getEnvironmentConstant = ({ key, env }) => {
  if (ENVIRONMENT_CONSTANTS[env] && ENVIRONMENT_CONSTANTS[env][key]) {
    const defaultValue = ENVIRONMENT_CONSTANTS[env][key];
    // Fetch env data for MFE
    if (typeof window?.adsk?.components?.learnAnywhereMFE?.envData[key] !== 'undefined') {
      return window?.adsk?.components?.learnAnywhereMFE?.envData[key];
    }
    // Fetch env data for SPA
    if (typeof window[PRELOADED_STATE_KEY]?.envData[key] !== 'undefined') {
      return window[PRELOADED_STATE_KEY]?.envData[key];
    }
    // Fetch env data for Node
    if (typeof process?.env[key] !== 'undefined') {
      // Add Validation
      if (AWS_ENV_VARS[key]) {
        const processEnv = `${process.env[key]}`;
        if (AWS_ENV_VARS[key].default || processEnv) { // If not set and no default available hide the key
          if (typeof AWS_ENV_VARS[key].validator === 'function') {
            return AWS_ENV_VARS[key].validator(processEnv) ? processEnv : AWS_ENV_VARS[key].default;
          }
          return processEnv || AWS_ENV_VARS[key].default;
        }
      }
      return `${process.env[key]}`;
    }
    return defaultValue;
  }
  // SSM-backed keys removed from ENVIRONMENT_CONSTANTS
  if ([WTIH_APIKEY, WTIH_SECRET, UGC_FILTER_KEY].includes(key)) {
    if (typeof window?.adsk?.components?.learnAnywhereMFE?.envData?.[key] !== 'undefined') {
      return window.adsk.components.learnAnywhereMFE.envData[key];
    }
    if (typeof window?.[PRELOADED_STATE_KEY]?.envData?.[key] !== 'undefined') {
      return window[PRELOADED_STATE_KEY].envData[key];
    }
    if (typeof process?.env?.[key] !== 'undefined') {
      return `${process.env[key]}`;
    }
  }
  logger.error(`${key} not found in environment constants config for env ${env}`);
  return null;
};

export const stripTrailingSlash = (str) => (str.endsWith('/') ? str.slice(0, -1) : str);

// Flatten array of arrays
export const flatDeep = (arr, d = 1) => (d > 0
  ? arr.reduce((acc, val) => acc.concat(Array.isArray(val)
    ? flatDeep(val, d - 1) : val), [])
  : arr.slice());

export const getParentModule = ({ curatedData, unitId }) => {
  if (curatedData.tutorials && curatedData.unitLookup && curatedData.unitLookup[unitId] && curatedData.unitLookup[unitId].parentId) {
    const { parentId } = curatedData.unitLookup[unitId];
    const filteredMods = curatedData.tutorials.filter((mod) => mod.id === parentId);
    if (filteredMods.length) {
      return filteredMods[0];
    }
  }

  return {};
};

export const generateLRSID = ({ id, env }) => `https://cdn.contentful.com/spaces/${getEnvironmentConstant({ key: CONTENTFUL_SPACE_ID, env })}/environments/${getEnvironmentConstant({ key: CONTENTFUL_ENVIRONMENT_ID, env })}/entries/${id}`;

export const contentIdentityFromSys = (sys) => {
  const identity = {};
  if (sys?.id != null) {
    identity.id = sys.id;
  }
  if (sys?.publishedVersion != null) {
    identity.contentVersion = sys.publishedVersion;
  }
  return identity;
};

// Split large array into array of smaller arrays
export const chunkArray = chunkArrayFunc;

export const generateUnitCanonicalURL = ({
  contextUri, host, unitId, env,
}) => {
  if (host.startsWith('http://') || host.startsWith('https://')) {
    return `${host}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}${contextUri}/${unitId}`;
  }
  return `https://${host}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}${contextUri}/${unitId}`;
};

export const generateSearchLRSID = ({ env, stateString }) => `${getEnvironmentConstant({ env, key: SEARCH_API })}/${stateString}`;

export const generateLRSContext = ({
  curatedData, unitId, tutorialId, env, stateString, purpose, tutorialData,
}) => {
  const retContext = {};
  retContext.application = LRS_APPID_LRNO;

  if (unitId) {
    if (curatedData && Object.keys(curatedData).length) {
      const unit = curatedData.unitLookup[unitId];
      retContext.parent = `urn:module:${generateLRSID({ id: unit.parentId, env })}`;
      retContext.grouping = `urn:course:${generateLRSID({ id: curatedData.id, env })}`;
    }
    if (tutorialData && Object.keys(tutorialData).length) {
      retContext.parent = `urn:module:${generateLRSID({ id: tutorialData.id, env })}`;
    }
  } else if ((curatedData && Object.keys(curatedData).length)) {
    // Don't add subcategory to unit
    retContext.subcategory = `https://www.autodesk.com/learn/catalog/learningMode/${curatedData.learningMode || 'undefined'}`;
  } else if ((tutorialData && Object.keys(tutorialData).length)) {
    // Don't add subcategory to unit
    retContext.subcategory = `https://www.autodesk.com/learn/catalog/learningMode/${tutorialData.learningMode || 'undefined'}`;
  }

  if (tutorialId) {
    if (curatedData?.id) {
      retContext.parent = `urn:course:${generateLRSID({ id: curatedData.id, env })}`;
    }
  }

  if (typeof stateString !== 'undefined' && curatedData) {
    retContext.category = generateSearchLRSID({ env, stateString });
  }

  if (purpose) {
    if (!retContext[LRS_CONTEXT_EXTENSIONS]) {
      retContext[LRS_CONTEXT_EXTENSIONS] = {};
    }
    retContext[LRS_CONTEXT_EXTENSIONS][LRS_EXTENSIONS_PURPOSE] = purpose;
  }

  return retContext;
};

// Generate URN for LRS Producer API
export const generateURN = ({
  uid, verb, lrsId, type,
}) => `${uid}:${verb}:urn:${type}:${lrsId}`;

export const validateURN = (urn) => {
  if (typeof urn !== 'string') {
    logger.error(`Bad URN: |${urn}| is not a string`);
    return false;
  }

  const splitURN = urn.split(':');
  const splitRemappedURN = splitURN.map((part) => part.replace(/ /g, ''));

  if (urn.startsWith(':')) {
    logger.error(`Bad URN: |${urn}| starts with :`);
    return false;
  }

  if (splitURN.length < 5) {
    logger.error(`Bad URN: |${urn}| less than 5 parts, has ${splitURN.length}`);
    return false;
  }

  if (splitRemappedURN[0].length < 4) {
    logger.error(`Bad URN: |${urn}| id is less than 4 characters`);
    return false;
  }

  if (splitRemappedURN[0] === 'undefined') {
    logger.error(`Bad URN: |${urn}| id is "undefined"`);
    return false;
  }

  return true;
};

export const updateURNID = ({
  uid, urn,
}) => urn.split(':').map((key, idx) => (idx < 1 ? uid : key)).join(':');

// Generate list of all object ids in a course that could have LRS records: course, unit, problem
export const generateRecordFetchingList = ({ curatedData, tutorialData, env }) => {
  let unitLookup;
  let tutorials;
  let tutorialList = [];
  let gradedProblemList = [];

  // Start list with units
  if (curatedData) {
    ({ unitLookup, tutorials } = curatedData);
    tutorialList = tutorials?.map((mod) => generateLRSID({ id: mod.id, env })) || [];
    gradedProblemList = curatedData?.gradedItems?.map((gradedItem) => generateLRSID({ id: gradedItem.id, env })) || [];
  }

  if (tutorialData) {
    ({ unitLookup = {} } = tutorialData);
    tutorialList = [generateLRSID({ id: tutorialData.id, env })];
  }

  const unitList = unitLookup && Object.keys(unitLookup).map((unitId) => generateLRSID({ id: unitId, env }));
  const recordList = unitList.concat([...tutorialList], [...gradedProblemList]);
  if (curatedData) {
    // Add curated to list
    recordList.push(generateLRSID({
      id: curatedData.id,
      env,
    }));
  }
  return [...new Set(recordList)];
};

// Order curated pages in the entire curated tree
export const orderCuratedIds = ({ tutorials }) => {
  const arraysOfBlocks = tutorials?.map(
    (tutorial) => tutorial?.units?.map(
      (unit) => unit?.id,
    ) || [],
  ) || [];

  const flatIds = flatDeep(arraysOfBlocks, 3);

  return flatIds;
};

export const getLocaleString = () => {
  if (Intl && typeof Intl.NumberFormat === 'function') {
    return (new Intl.NumberFormat()).resolvedOptions().locale;
  }

  // Default to en-us
  return 'en-US';
};

export const generateCanonicalURL = ({ location, requestHost, env }) => {
  if (requestHost?.startsWith('http://') || requestHost?.startsWith('https://')) {
    return `${requestHost}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}${decodeURIComponent(location.pathname)}`;
  }
  return `https://${requestHost}${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}${decodeURIComponent(location.pathname)}`;
};

// Implement Durstenfeld shuffle
export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    // eslint-disable-next-line no-param-reassign
    [array[i], array[j]] = [array[j], array[i]];
  }
}

export const getCourseAPIHost = ({ env, isPreview = false, isSSR = false }) => {
  // Use same host for front-end
  if (window?.location?.origin && !window?.location?.origin.startsWith('https://localhost')) {
    if (isSSR) {
      logger.debug('getCourseAPIHost SRR: found window');
    }
    return window.location.origin;
  }

  // Handle generating a host name for SSR
  if (isPreview) {
    if (isSSR) {
      logger.debug('getCourseAPIHost SRR: isPreview', getEnvironmentConstant({ env, key: COURSE_PREVIEW_API_HOST }));
    }
    return getEnvironmentConstant({ env, key: COURSE_PREVIEW_API_HOST });
  }
  if (isSSR) {
    logger.debug('getCourseAPIHost SRR: is not preview', getEnvironmentConstant({ env, key: COURSE_API_HOST }));
  }
  return getEnvironmentConstant({ env, key: COURSE_API_HOST });
};

export const getLLRecordFilter = ({ env }) => `https://cdn.contentful.com/spaces/${getEnvironmentConstant({ env, key: CONTENTFUL_SPACE_ID })}/environments/${getEnvironmentConstant({ env, key: CONTENTFUL_ENVIRONMENT_ID })}/entries/`;

export const calculateEffortDisplay = (totalMinutes) => {
  if (Number.isInteger(totalMinutes)) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours > 0) {
      if (minutes > 0) {
        return `${hours} hr. ${minutes} min.`;
      }
      return `${hours} hr.`;
    }
    return `${minutes} min.`;
  }
  return null;
};

// Get an element's distance from the top of the page
export const getElemDistance = (elem) => {
  let location = 0;
  if (elem.offsetParent) {
    do {
      location += elem.offsetTop;
      // eslint-disable-next-line no-param-reassign
      elem = elem.offsetParent;
    } while (elem);
  }
  return location >= 0 ? location : 0;
};

export const generateCatalogStateStringFromResult = ({ result, resultOverride, returnPage = false }) => {
  const splits = [];
  const res = { ...result, ...resultOverride };

  if (res?.term?.length) {
    splits.push(encodeURIComponent(result.term));
  }
  const keys = [];
  const vals = [];

  const parseFilters = (filters) => {
    filters.forEach((filter) => {
      const filteredSelections = filter.selections ? filter.selections.filter((selection) => selection.selected) : [];
      if (filteredSelections.length) {
        keys.push(filter.id);
        vals.push(filteredSelections.map((selection) => selection.value).join(','));
      }
    });
  };

  if (res?.filterGroups?.length) {
    res.filterGroups.forEach((filterGroup) => {
      if (filterGroup.filters?.length) {
        parseFilters(filterGroup.filters);
      }
    });
  }

  if (res?.filters?.length) {
    parseFilters(res.filters);
  }

  if (res?.page > 1 && returnPage) {
    keys.push('page');
    vals.push(res?.page);
  }

  if (res?.sort) {
    keys.push('sort');
    vals.push(res?.sort);
  }

  if (keys.length && vals.length) {
    splits.push(keys.join('|'));
    splits.push(vals.join('|'));
  }

  return splits.join('/');
};

export const reformatCuratedType = (type) => {
  if (type) {
    return type.charAt(0).toUpperCase() + type.toLowerCase().replace('-', ' ').slice(1);
  }
  return type;
};

export const getInnerText = (obj) => {
  if (obj?.props?.children) {
    if (Array.isArray(obj.props.children)) {
      const map = obj.props.children.map((child) => {
        if (child?.props?.children) {
          return getInnerText(child);
        }
        if (typeof child === 'string') {
          return child;
        }
        // If child is an object without string children eg <br/> then return empty string
        return '';
      });
      return map.filter((str) => str !== '').join(' ');
    }
    return obj.props.children;
  }
  return obj;
};

export const addUniversalContext = ({ context }) => {
  if (context) {
    const retContext = { ...context };
    retContext.application = LRS_APPID_LRNO;
    return retContext;
  }

  return context;
};

export function serializeElement(element) {
  const replacer = (key, value) => {
    switch (key) {
    case '_owner':
    case '_store':
    case 'ref':
    case 'key':
      return;
    default:
      // eslint-disable-next-line consistent-return
      return typeof value === 'symbol' ? Symbol.keyFor(value) : value;
    }
  };

  return JSON.stringify(element, replacer);
}

function deserializeElem(element, options = {}, key) {
  let {
    components = {
      'react.forward_ref': Link,
      'react.fragment': Fragment,
    },
  } = options;

  const {
    functions = {
      loginClickHandler: LoginClickHandler,
    },
    reviver,
  } = options;

  if (typeof element !== 'object') {
    return element;
  }

  if (element === null) {
    return element;
  }

  if (element instanceof Array) {
    return element.map((el, i) => deserializeElem(el, options, i));
  }

  // Now element has following shape { type: string, props: object }
  let { type, props } = element;

  if (typeof type !== 'string') {
    type = type.$$typeof || 'unknown.element';

    // throw new Error('Deserialization error: element type must be string');
  }
  type = components[type] || type.toLowerCase();

  if (props.children) {
    props = { ...props, children: deserializeElem(props.children, options) };
  }

  if (props['data-functions']) {
    Object.keys(props['data-functions']).forEach((k) => {
      props[k] = functions[props['data-functions'][k]];
    });
    delete props['data-functions'];
  }

  if (reviver) {
    ({
      // eslint-disable-next-line no-param-reassign
      type, props, key, components,
    } = reviver(type, props, key, components));
  }

  return React.createElement(type, { ...props, key });
}

export function deserializeElement(data, options) {
  if (typeof data === 'string') {
    // eslint-disable-next-line no-param-reassign
    data = JSON.parse(data);
  }
  if (data instanceof Object) {
    return deserializeElem(data, options);
  }
  throw new Error('Deserialization error: incorrect data type');
}

export const mergeLocalStorage = ({ payload, id, env }) => {
  let data = {};
  let allSavedRecords = '{}';
  const idKey = id ? `${oneWayHash(id)}-${id}` : LOCAL_STORAGE_ANONYMOUS_ID;
  try {
    allSavedRecords = localStorage.getItem(LOCAL_STORAGE_LRS_KEY) || '{}';
    const savedRecords = JSON.parse(allSavedRecords)[idKey] || {};
    Object.keys(savedRecords).forEach((key) => {
      if (!key.startsWith(getLLRecordFilter({ env }))) {
        delete savedRecords[key];
      } else {
        // Clean Malformed data
        if (savedRecords[key].statements) {
          savedRecords[key].statements = savedRecords[key].statements.filter((stat) => !!stat.context);
        }
        if (savedRecords[key].context) {
          delete savedRecords[key].context;
        }
        if (savedRecords[key].application) {
          delete savedRecords[key].application;
        }
      }
    });
    data = deepmerge(savedRecords, payload);
  } catch (e) {
    logger.error('Failed parsing local storage', e);
    data = payload;
  }
  return data;
};

export const getFilesSizes = async (urlList) => Promise
  .all(urlList.map(
    (url) => axios.head(url).catch(() => ({})),
  ))
  .then((resp) => Object.fromEntries(resp.map((data, idx) => {
    if (!Object.keys(data).includes('headers')) {
      return [urlList[idx], ''];
    }
    const size = data?.headers['content-length'];
    let sizeString;
    if (Number.isNaN(size)) {
      return [urlList[idx], ''];
    }
    if (size < 1024) {
      sizeString = `${size} b`;
    } else if (size < 1048576) {
      sizeString = `${Math.round(size / 1024)} kb`;
    } else {
      sizeString = `${Math.round(size / 1048576)} mb`;
    }
    return [urlList[idx], sizeString];
  })));

export const parseProblemData = ({ problemId, problemData }) => {
  if (typeof problemData === 'string') {
    try {
      const data = JSON.parse(problemData);
      return data;
    } catch (e) {
      logger.error(`Failed parsing problemData: ${problemId}`);
      return {};
    }
  }
  return problemData;
};

export const isEdgeBrowser = () => {
  if (window?.navigator?.userAgent) {
    return /Edg/.test(window.navigator.userAgent);
  }

  return false;
};

export const optimizeContentfulImage = ({
  url, width, height, env,
}) => {
  let imageUrl = url;
  if (imageUrl?.startsWith('https://images.ctfassets.net/')) {
    imageUrl += `?fm=${isEdgeBrowser() ? 'jpg' : 'avif'}`;
    if (width) {
      imageUrl += `&w=${width}`;
    }
    if (height) {
      imageUrl += `&h=${height}`;
    }
  }
  const hostConstant = getEnvironmentConstant({ env, key: FILEMANAGER_PROXY_HOST });
  // console.log('hostConstant: ', hostConstant);
  if (hostConstant?.startsWith('https://') && imageUrl?.startsWith(hostConstant)) {
    imageUrl = `${getEnvironmentConstant({ env, key: COURSE_API_HOST })}${getEnvironmentConstant({ env, key: ROUTER_BASENAME })}/api/image/v1/${encodeURIComponent(imageUrl)}`;
  }
  return imageUrl;
};

export const LRSHasVerbRecordForID = ({
  learningRecords, id, env, verb,
}) => {
  const recordId = generateLRSID({ id, env });
  if (learningRecords && learningRecords[recordId] && learningRecords[recordId].statements) { // If learning record for this id exists
    const verbStatements = learningRecords[recordId].statements.filter((statement) => statement.verb === verb);
    if (verbStatements.length) { // Found a completed statement for this child.
      return true;
    }
  }

  return false;
};

// Order course pages in the entire course tree
export const orderCourseIds = ({ modules }) => {
  const arraysOfBlocks = modules?.map(
    (module) => module?.units?.map(
      (unit) => unit?.id,
    ) || [],
  ) || [];

  const flatIds = flatDeep(arraysOfBlocks, 3);

  return flatIds;
};

export const getUnitsAndModulesInCourse = ({ tutorials }) => {
  if (tutorials && tutorials.map) {
    const arraysOfUnits = tutorials.map(
      (tutorial) => (tutorial?.units?.length ? [tutorial, ...tutorial.units] : [tutorial]),
    ) || [];

    const flatUnits = flatDeep(arraysOfUnits, 2);

    return flatUnits;
  }

  return [];
};

export const getNextIncompleteUrl = ({
  type, courseUri, orderedIds, learningRecords, env,
}) => {
  // Find all items that have not been completed
  // console.log(orderedIds);
  const incompleteIds = orderedIds.filter((typeId) => {
    const recUrl = generateLRSID({ id: typeId, env });
    const record = learningRecords[recUrl];
    if (record
      && record.statements
      && record.statements.filter(
        (statement) => statement.verb === LRS_VERB_COMPLETED,
      ).length !== 0) {
      return false;
    }

    return true;
  });

  if (incompleteIds.length) {
    // Redirect to first incomplete item
    return `${courseUri}/${type}/${incompleteIds[0]}`;
  }

  return `${courseUri}`;
};

export const getLearningPlanServiceHost = ({ env }) => (
    `${getEnvironmentConstant({
      env,
      key: LEARNING_PLAN_HOST_COMMON,
    })}`);

export const mapUnitData = ({ moduleData, learningRecords, env }) => moduleData?.units.map((unit) => {
  const isCompleted = LRSHasVerbRecordForID({
    learningRecords, id: unit.id, env, verb: LRS_VERB_COMPLETED,
  });

  return {
    ...unit,
    ...moduleData?.unitLookup[unit.id],
    uri: `${moduleData.uri}/unit/${unit.id}`,
    isCompleted,
  };
});

// Validate if a given unit has a completed LRS record
export const unitHasCompleteRecord = ({ learningRecords, id, env }) => LRSHasVerbRecordForID({
  learningRecords, id, env, verb: LRS_VERB_COMPLETED,
});

export const allUnitsInModuleComplete = ({
  learningRecords, module, currentCompletedId, env,
}) => {
  const reducer = (accumulator, currentUnit) => {
    if (accumulator && (currentUnit.id === currentCompletedId || unitHasCompleteRecord({
      learningRecords, env, id: currentUnit.id,
    }))) { // If already true && block is complete
      return true;
    }
    return false;
  };
  return module.units ? module.units.reduce(reducer, true) : true;
};

export const getIncompleteProblemsList = ({
  courseOutline, learningRecords, itemId, env,
}) => {
  if (courseOutline && courseOutline.gradedItems && courseOutline.gradedItems.filter) {
    return courseOutline.gradedItems.filter((gradedItem) => {
    // eslint-disable-next-line no-unused-vars
      const { id } = gradedItem;

      // Shortcut for just completed quiz that is not updated in record store yet
      if (id === itemId) {
        return false;
      }

      // If LRS record not found or does not contain completed statement return true - "incomplete graded problem"
      const problemUrl = generateLRSID({ id, env });
      if (!learningRecords[problemUrl]
        || !learningRecords[problemUrl].statements
        || learningRecords[problemUrl].statements.filter((statement) => statement.verb === LRS_VERB_COMPLETED).length < 1) {
        return true;
      }
      return false;
    });
  }
  return false;
};

export const shouldFireGradedComplete = ({
  learningRecords, courseOutline, itemId, env,
}) => {
  if (courseOutline && courseOutline.gradedItems && learningRecords) {
    // Check if course complete statement already exists
    const courseRecordId = generateLRSID({ id: courseOutline.id, env });
    if (!learningRecords[courseRecordId]
                || !learningRecords[courseRecordId].statements
                || learningRecords[courseRecordId].statements.filter((statement) => statement.verb === LRS_VERB_COMPLETED).length < 1) {
      // Completed record not found so let's see if course is complete

      const incompleteGradedProblems = getIncompleteProblemsList({
        courseOutline, learningRecords, itemId, env,
      });

      // If no incomplete graded problems then course is complete
      if (!incompleteGradedProblems.length) {
        return true;
      }
    }
  }

  return false;
};

export const replaceProductToken = ({ text, productName, link }) => {
  if (!text || !productName) {
    return text;
  }
  // Regular expression to match the placeholder with curly braces
  const placeholderRegex = /\{[^}]+\}/g;

  return text.replace(placeholderRegex, (!link && productName.includes(',')) ? 'your products' : productName);
};

export const getUserTimezone = () => {
  let timezone = '';

  if (typeof Intl === 'object' && typeof Intl.DateTimeFormat === 'function') {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } else if (typeof process === 'object' && process.env.TZ) {
    timezone = process.env.TZ;
  }

  return timezone;
};

export const getUserGMTOffset = () => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetMinutes / 60));
  const sign = offsetMinutes > 0 ? '-' : '+';
  const paddedHours = String(offsetHours).padStart(2, '0');
  const paddedMinutes = String(Math.abs(offsetMinutes % 60)).padStart(2, '0');

  return `${sign}${paddedHours}:${paddedMinutes}`;
};

export const getRecentSearchTerms = (fieldValue) => {
  let getStoredItems = [];
  if (window.sessionStorage.getItem('recentSearchItems')) {
    getStoredItems = JSON.parse(window.sessionStorage.getItem('recentSearchItems'));
  }
  if (fieldValue && getStoredItems.indexOf(fieldValue) === -1) {
    if (getStoredItems.length < 5) {
      window.sessionStorage.setItem('recentSearchItems', JSON.stringify([fieldValue, ...getStoredItems]));
    } else {
      getStoredItems.pop();
      getStoredItems.unshift(fieldValue);
      window.sessionStorage.setItem('recentSearchItems', JSON.stringify([...getStoredItems]));
    }
  }
};

export const getExperimentationSegment = (context) => {
  // check for empty context
  if (Object.keys(context).length === 0) {
    return {
      segmentKey: '', segmentValue: '', valid: false, segmentType: 'control',
    };
  }
  const possibleKeys = [
    PERSONALIZATION_EXPERIMENT_ACTIVETRIALONLY, PERSONALIZATION_EXPERIMENT_ACTIVECOMMONLY, PERSONALIZATION_EXPERIMENT_ACTIVETRIALANDCOMM, PERSONALIZATION_EXPERIMENT_EXPIREDTRIALONLY, INDUSTRY_RELEVANT_LEARNING_AND_CERT_PREP];
  const treatmentVals = [PERSONALIZATION_EXPERIMENT_ATOTREATMENT, PERSONALIZATION_EXPERIMENT_ACOTREATMENT, PERSONALIZATION_EXPERIMENT_ATACTREATMENT, PERSONALIZATION_EXPERIMENT_ETOTREATMENT, IRLCP_EXPERIMENT_TREATMENT];
  const controlVals = [PERSONALIZATION_EXPERIMENT_ATOCONTROL, PERSONALIZATION_EXPERIMENT_ACOCONTROL, PERSONALIZATION_EXPERIMENT_ATACCONTROL, PERSONALIZATION_EXPERIMENT_ETOCONTROL, IRLCP_EXPERIMENT_CONTROL];
  let retObj = {};
  possibleKeys.forEach((item) => {
    if (context[item] !== undefined) {
      retObj = { segmentKey: item, segmentValue: context[item] || '' };
    }
  });
  const valid = ([...treatmentVals, ...controlVals].includes(retObj?.segmentValue) && possibleKeys.includes(retObj?.segmentKey));
  const segmentType = retObj?.segmentValue?.includes('Control') ? PERSONALIZATION_EXPERIMENT_CONTROL : PERSONALIZATION_EXPERIMENT_TREATMENT;
  return valid ? { ...retObj, segmentType } : { segmentKey: '', segmentValue: '', segmentType: PERSONALIZATION_EXPERIMENT_CONTROL };
};

export const getEnrollmentSlug = ({ locale }) => {
  switch (locale) {
  case 'en-US':
    return EDC_SLUGS_ENROLLMENT_EN_US;
  case 'zh-CN':
    return EDC_SLUGS_ENROLLMENT_ZH_CN;
  case 'ko-KR':
    return EDC_SLUGS_ENROLLMENT_KO_KR;
  case 'ja-JP':
    return EDC_SLUGS_ENROLLMENT_JA_JP;
  case 'it-IT':
    return EDC_SLUGS_ENROLLMENT_IT_IT;
  case 'fr-FR':
    return EDC_SLUGS_ENROLLMENT_FR_FR;
  case 'es-ES':
    return EDC_SLUGS_ENROLLMENT_ES_ES;
  case 'de-DE':
    return EDC_SLUGS_ENROLLMENT_DE_DE;
  default:
    return EDC_SLUGS_ENROLLMENT_EN_US;
  }
};

export const AutodeskGenericIcon = () => (
  <svg id="autodeskGenericIcon" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <rect width="36" height="36" fill="url(#pattern0)" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_77_90" transform="scale(0.00666667)" />
      </pattern>
      <image id="image0_77_90" width="150" height="150" xlinkHref="data:image/png;base64,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" />
    </defs>
  </svg>
);

export const getDefaultCoachingCatalogFilters = () => COACHING_CATALOG_ACTIVE_FILTERS.reduce((filters, filterName) => {
  filters[filterName] = []; // eslint-disable-line no-param-reassign
  return filters;
}, {});

export const truncatePillText = (text) => {
  const maxCharCount = 35;
  if (!text || text?.length < maxCharCount) {
    return text;
  }

  const truncatedText = text.substring(0, maxCharCount);
  const lastSpaceIndex = truncatedText.lastIndexOf(' ');
  const hasSpace = lastSpaceIndex > 0;
  const truncatedToLastSpace = hasSpace ? truncatedText.substring(0, lastSpaceIndex) : truncatedText;

  return `${truncatedToLastSpace}...`;
};

export const determineCoachingType = ({ courseDetailData, coachingTypeData }) => {
  // Handle undefined or null courseDetailData
  const { coachingType } = courseDetailData || {};
  // From the course in contentful, we get the coaching type as a string.
  // We need to determine the coaching type based on the string.
  // If the string includes 'product' or 'business', we return the PRODUCT coaching type.
  // If the string includes 'admin', we return the ADMIN coaching type.
  // In case of fast track, courseDetailData will have meta object with type as 'fastTrackLearningPlan'.
  // In this case, we return the FASTRACK coaching type.
  // Otherwise, we return the SYSTEM coaching type.
  const coachingTypeString = Array.isArray(coachingType) ? coachingType[0] : coachingType;
  if (courseDetailData.meta?.type === 'fastTrackLearningPlan') {
    return coachingTypeData[COACHING_TYPE_KEY_FAST_TRACK];
  }
  if (typeof coachingTypeString !== 'string' || coachingTypeString.length === 0) {
    return {};
  }
  if (coachingTypeString?.toLowerCase().includes('product') || coachingTypeString?.toLowerCase().includes('business')) {
    return coachingTypeData[coachTypeConstants.PRODUCT];
  }
  if (coachingTypeString?.toLowerCase().includes('admin')) {
    return coachingTypeData[coachTypeConstants.ADMIN];
  }
  return coachingTypeData[coachTypeConstants.SYSTEM];
};

export const makeUrlFriendly = (str = '') => {
  if (typeof str !== 'string') return '';
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove non-alphanumeric except space and dash
    .replace(/\s+/g, '-') // Replace whitespace with dash
    .replace(/-+/g, '-') // Collapse multiple dashes
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing dashes
};

window.getInnerText = getInnerText;

/**
 * Sort courses by title (A-Z or Z-A)
 * @param {Array} courses - Array of course objects
 * @param {string} sortDirection - 'title_ASC' for A-Z, 'title_DESC' for Z-A
 * @returns {Array} Sorted array of courses
 */
export const sortCoursesByTitle = (courses, sortDirection = 'title_ASC') => {
  if (!courses || !Array.isArray(courses)) {
    return [];
  }

  return [...courses].sort((a, b) => {
    const titleA = (a.title || '').toLowerCase();
    const titleB = (b.title || '').toLowerCase();

    if (sortDirection === 'title_DESC') {
      return titleB.localeCompare(titleA);
    }
    return titleA.localeCompare(titleB);
  });
};

/**
 * Sort coaching catalog courses by relevance based on user's owned products
 * @param {Array} courses - Array of course objects
 * @param {Array} userEntitlements - Array of user's product entitlements
 * @param {string} fallbackSort - Fallback sort method ('title_ASC' or 'title_DESC')
 * @returns {Array} Sorted array of courses
 */
export const sortCoursesByRelevance = (courses, userEntitlements, fallbackSort = 'title_ASC') => {
  if (!courses || !Array.isArray(courses)) {
    return [];
  }

  // Extract user's owned product identifiers (PLCs and GUIDs)
  const ownedProductIds = new Set();
  if (userEntitlements && Array.isArray(userEntitlements)) {
    userEntitlements.forEach((entitlement) => {
      if (entitlement.active) { // Only consider active entitlements
        if (entitlement.plc) ownedProductIds.add(entitlement.plc);
        if (entitlement.guid) ownedProductIds.add(entitlement.guid);
      }
    });
  }

  // If user has no owned products, fallback to alphabetical sort
  if (ownedProductIds.size === 0) {
    return sortCoursesByTitle(courses, fallbackSort);
  }

  // Categorize courses based on user's product ownership
  const ownedProductCourses = [];
  const unownedProductCourses = [];

  courses.forEach((course) => {
    const hasOwnedProduct = course.relatedProductsCollection?.items?.some((product) => (
      ownedProductIds.has(product.plc) || ownedProductIds.has(product.guid)
    )) || false;

    if (hasOwnedProduct) {
      ownedProductCourses.push(course);
    } else {
      unownedProductCourses.push(course);
    }
  });

  // Sort each category by product name (alpha order)
  const sortByProductName = (courseA, courseB) => {
    const getFirstProductName = (course) => course.relatedProductsCollection?.items?.[0]?.name || course.title || '';

    const nameA = getFirstProductName(courseA).toLowerCase();
    const nameB = getFirstProductName(courseB).toLowerCase();

    return nameA.localeCompare(nameB);
  };

  ownedProductCourses.sort(sortByProductName);
  unownedProductCourses.sort(sortByProductName);

  // Return owned products first, then unowned products
  return [...ownedProductCourses, ...unownedProductCourses];
};

/**
 * Apply sorting to coaching catalog courses based on sort value and user entitlements
 * @param {Array} courses - Array of course objects
 * @param {string} sortValue - Sort method ('relevance', 'title_ASC', 'title_DESC')
 * @param {Array} userEntitlements - Array of user's product entitlements
 * @returns {Array} Sorted array of courses
 */
export const applyCatalogSorting = (courses, sortValue, userEntitlements = []) => {
  if (!courses || !Array.isArray(courses)) {
    return [];
  }

  switch (sortValue) {
  case 'relevance':
    return sortCoursesByRelevance(courses, userEntitlements, 'title_ASC');
  case 'title_ASC':
    return sortCoursesByTitle(courses, 'title_ASC');
  case 'title_DESC':
    return sortCoursesByTitle(courses, 'title_DESC');
  default:
    // Default to relevance if user has entitlements, otherwise A-Z
    if (userEntitlements.length > 0) {
      return sortCoursesByRelevance(courses, userEntitlements, 'title_ASC');
    }
    return sortCoursesByTitle(courses, 'title_ASC');
  }
};

export const getLearningPlanLabelByType = (type) => {
  switch (type) {
  case 'FastTrack':
    return 'Fast track service learning plan';
  default:
    return 'Learning Plan';
  }
};

/**
 * Pluralize a phrase based on the count
 * @param {Number} count - The count of the item
 * @param {String} singular - The singular form of the item. This can contain the string '[count]' which will be replaced with the count. Otherwise, the count will be prepended to the singular form.
 * @param {String} plural - The plural form of the item. This can contain the string '[count]' which will be replaced with the count. Otherwise, the count will be prepended to the plural form.
 * @returns {String} The pluralized phrase
 */
export const pluralize = (count, singular, plural) => {
  if (count === 1) {
    if (singular.indexOf('[count]') !== -1) {
      return singular.replace('[count]', count);
    }
    return `${count} ${singular}`;
  }
  if (plural.indexOf('[count]') !== -1) {
    return plural.replace('[count]', count);
  }
  return `${count} ${plural}`;
};

/**
 * Format text with escape sequences and pseudo bullet lists to HTML
 * Converts newlines to <br> tags, tabs to spaces, and lines starting with "-" or "- " to proper HTML lists
 * All output is sanitized with DOMPurify to prevent XSS attacks
 * @param {String} text - The text to format
 * @param {String} fallbackText - Optional fallback text if input is empty
 * @returns {String} Sanitized HTML string
 */
export const formatOverviewText = (text, fallbackText = '') => {
  // Validate input type for robustness
  if (!text || typeof text !== 'string') return fallbackText;

  // Split text into lines
  const lines = text.split('\n');
  const htmlParts = [];
  let inList = false;

  lines.forEach((line, index) => {
    const trimmedLine = line.trim();
    // Check if line starts with "- " or "-" followed by content
    // Uses non-backtracking pattern to prevent ReDoS
    const isBullet = /^-\s+\S/.test(trimmedLine) || /^-\S/.test(trimmedLine);
    const isLastLine = index === lines.length - 1;

    if (isBullet) {
      // Extract the bullet content (remove the leading "- " or "-")
      const bulletContent = trimmedLine.replace(/^-\s*/, '');

      if (!inList) {
        // Start a new list
        htmlParts.push('<ul>');
        inList = true;
      }
      // Content will be sanitized by DOMPurify at the end
      htmlParts.push(`<li>${bulletContent}</li>`);
    } else {
      if (inList) {
        // Close the list
        htmlParts.push('</ul>');
        inList = false;
      }
      // Add the line with a line break
      // Respect all line breaks including multiple consecutive empty lines
      if (trimmedLine) {
        // Content will be sanitized by DOMPurify at the end
        htmlParts.push(trimmedLine);
        // Don't add trailing <br> on the last line
        if (!isLastLine) {
          htmlParts.push('<br>');
        }
      } else if (!isLastLine) {
        // Empty line - add <br> to preserve spacing (but not on the very last line)
        htmlParts.push('<br>');
      }
    }
  });

  // Close list if still open
  if (inList) {
    htmlParts.push('</ul>');
  }

  // Join and handle tabs
  const formatted = htmlParts.join('').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');

  // DOMPurify sanitizes all content to prevent XSS attacks
  return DOMPurify.sanitize(formatted);
};

/**
 * Ensures a string has the specified prefix
 * Prevents duplicate prefix if string already starts with it
 * @param {String} str - The string to check/prepend
 * @param {String} prefix - The prefix to prepend
 * @returns {String} String with prefix
 */
export const ensurePrefix = (str, prefix) => {
  if (!str) return str;
  if (!prefix) return str;
  // Validate that both parameters are strings to safely use .startsWith()
  if (typeof str !== 'string' || typeof prefix !== 'string') {
    return str;
  }
  // Check if the string already starts with the prefix
  if (str.startsWith(prefix)) {
    return str;
  }
  // Prepend the prefix
  return `${prefix}${str}`;
};

export const isCoursePath = (path) => path.includes('/ondemand/course/');
